export default "__VITE_ASSET__x3Ldav5O__"